// @format

import {Litepicker} from 'litepicker'
import 'litepicker/dist/plugins/ranges'
import 'litepicker/dist/css/litepicker.css'
import 'litepicker/dist/css/plugins/ranges.js.css'
import Chartkick from 'chartkick'

function dateRange(start, end) {
  for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    arr.push(new Date(dt));
  }

  return arr;
};

function filteredDates(chartData, dates) {
  const _chartData = JSON.parse(JSON.stringify(chartData))

  for (var dataset of _chartData) {
    for (const [k, v] of Object.entries(dataset.data)) {
      if (!dates.includes(k)) {
        delete(dataset.data[k])
      }
    }
  }

  return _chartData
}

let activePicker: Litepicker | null = null

export function destroyLitepicker(): void {
  if (activePicker) {
    try { activePicker.destroy() } catch (_e) { /* already gone */ }
    activePicker = null
  }
  const pickerElement = document.getElementById("litepicker")
  if (pickerElement) delete pickerElement.dataset.loaded
}

export function initLitepicker(): void {
  const pickerElement = document.getElementById("litepicker")

  if (pickerElement && !pickerElement.dataset.loaded) {
    pickerElement.dataset.loaded = "true"
    pickerElement.classList.remove("disabled")
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const allTime = [new Date(1970, 0, 1), new Date(today.getTime() - 1)]
    const last7Days = [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7), new Date(today.getTime() - 1)]
    const last14Days = [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14), new Date(today.getTime() - 1)]
    const last30Days = [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30), new Date(today.getTime() - 1)]

    const picker = new Litepicker({
      element: pickerElement,
      scrollToDate: false,
      dropdowns: {
        minYear: allTime[0].getFullYear(),
        maxYear: today.getFullYear(),
        months: true,
        years: true
      },
      plugins: ["ranges"],
      ranges: {
        customRanges: {
          "All time": allTime,
          "Last 7 days": last7Days,
          "Last 14 days": last14Days,
          "Last 30 days": last30Days
        }
      }
    })
    activePicker = picker

    function updateLabel(startDate: Date, endDate: Date) {
      const timestamp1 = startDate.getTime()
      const timestamp2 = endDate.getTime()

      if (timestamp1 === +last7Days[0] && timestamp2 === +last7Days[1]) {
        $("#litepicker").html("<i class='fal fa-calendar-alt'></i> Last 7 days")
      } else if (timestamp1 === +last14Days[0] && timestamp2 === +last14Days[1]) {
        $("#litepicker").html("<i class='fal fa-calendar-alt'></i> Last 14 days")
      } else if (timestamp1 === +last30Days[0] && timestamp2 === +last30Days[1]) {
        $("#litepicker").html("<i class='fal fa-calendar-alt'></i> Last 30 days")
      } else if (timestamp1 === +allTime[0] && timestamp2 === +allTime[1]) {
        $("#litepicker").html("<i class='fal fa-calendar-alt'></i> All time")
      } else {
        $("#litepicker").html("<i class='fal fa-calendar-alt'></i> " +
                              startDate.toDateString().substring(4) +
                              " - " +
                              endDate.toDateString().substring(4))
      }
    }

    function persistDatesInURL(startTimestamp: number, endTimestamp: number, isAllTime: boolean) {
      const url = new URL(window.location.href)
      if (isAllTime) {
        url.searchParams.delete("start_date")
        url.searchParams.delete("end_date")
      } else {
        url.searchParams.set("start_date", String(startTimestamp))
        url.searchParams.set("end_date", String(endTimestamp))
      }
      window.history.replaceState({}, "", url.toString())
    }

    function syncFilterFormDates(startTimestamp: number, endTimestamp: number, isAllTime: boolean) {
      const startInputs = document.querySelectorAll<HTMLInputElement>('input[type="hidden"][name="start_date"]')
      const endInputs = document.querySelectorAll<HTMLInputElement>('input[type="hidden"][name="end_date"]')
      startInputs.forEach((input) => { input.value = isAllTime ? "" : String(startTimestamp) })
      endInputs.forEach((input) => { input.value = isAllTime ? "" : String(endTimestamp) })
    }

    function syncDateFilterLinks(startTimestamp: number, endTimestamp: number, isAllTime: boolean) {
      document.querySelectorAll<HTMLAnchorElement>('#campaign-status-seg a[href]').forEach((link) => {
        const url = new URL(link.href, window.location.origin)
        if (isAllTime) {
          url.searchParams.delete("start_date")
          url.searchParams.delete("end_date")
        } else {
          url.searchParams.set("start_date", String(startTimestamp))
          url.searchParams.set("end_date", String(endTimestamp))
        }
        link.href = url.toString()
      })
    }

    if (pickerElement.dataset.demoBot == "false") {
      const savedStart = pickerElement.dataset.startDate
      const savedEnd = pickerElement.dataset.endDate

      if (savedStart && savedStart !== "0" && savedEnd) {
        const startDate = new Date(parseInt(savedStart, 10))
        const endDate = new Date(parseInt(savedEnd, 10))
        picker.setDateRange(startDate, endDate)
        updateLabel(startDate, endDate)
        picker.gotoDate(endDate)
      } else {
        picker.setDateRange(allTime[0], allTime[1])
        $("#litepicker").html("<i class='fal fa-calendar-alt'></i> All time")
        picker.gotoDate(allTime[1])
      }
    }

    picker.on("selected", function(date1, date2) {
      const startAt = date1.dateInstance
      const endAt = date2.dateInstance

      startAt.setHours(0, 0, 0, 0)
      endAt.setHours(23, 59, 59, 999)

      picker.gotoDate(endAt)

      const timestamp1 = startAt.getTime()
      const timestamp2 = endAt.getTime()
      const isAllTime = timestamp1 === +allTime[0] && timestamp2 === +allTime[1]
      let args = {start_date: isAllTime ? 0 : timestamp1, end_date: timestamp2}

      $('#litepicker').attr('data-start-date', timestamp1)
      $('#litepicker').attr('data-end-date', timestamp2)

      updateLabel(startAt, endAt)

      if (pickerElement.hasAttribute("data-start-date")) {
        persistDatesInURL(timestamp1, timestamp2, isAllTime)
        syncFilterFormDates(timestamp1, timestamp2, isAllTime)
        syncDateFilterLinks(timestamp1, timestamp2, isAllTime)
      }

      const statsURL = $("#render-async-stats").data("url")
      $("#render-async-stats").html("<div class='d-flex align-items-center justify-content-center' style='min-height:400px'><div class='spinner-border text-primary'></div></div>")

      $.get(statsURL, args, function(data) {
        $("#render-async-stats").html(data)
        document.dispatchEvent(new Event("render_async_load"))
      })

      reload_async(args);
    })
  }
}

function reload_async(args: { start_date: number; end_date: number }) {
  const $asyncElements =  $(".async-container")

  $asyncElements.each((_, element) => {
    const url = $(element).data("url")
    
    $(element).html("<div class='d-flex align-items-center justify-content-center' style='min-height:400px'><div class='spinner-border text-primary'></div></div>")

    $.get(url, args, function(data) {
      $(element).html(data)
      document.dispatchEvent(new Event("render_async_load"))
    })
  })
}